import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { getStatusMeta } from '@/utils/statusModel';

export const StatusBadge = ({ listing, lastStatus, apiStatus, isRental, standardStatus, className }) => {
  const ls = listing ? listing.lastStatus : lastStatus;
  const as_ = listing ? listing.apiStatus : apiStatus;
  const rental = listing ? listing.isRental : isRental;
  const ss = listing ? listing.standardStatus : standardStatus;
  const { label, className: statusClass } = getStatusMeta(ls, as_, rental, ss);
  return (
    <Badge
      className={cn('rounded-full font-medium border-0', statusClass, className)}
      data-testid="listing-status-badge"
    >
      {label}
    </Badge>
  );
};
